import { getItemLocalStorage, selectAll } from "@utils/function";
import { InformationSettingsUpdate } from "./informationSettings";

export default function ChangeCheboxInInformation() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const hideItems = urlParams.get("hideItems");

  if (!hideItems) return;

  const hideItemsArray = hideItems.split(",").map(Number);

  const getAllDataLayerId = selectAll("[data-layer-id]");

  getAllDataLayerId.forEach((layer) => {
    const layerId = layer.dataset.layerId;
    const id = layer.dataset.id;

    if (!hideItemsArray.includes(+id)) return;

    if (CheckHideItems(layerId)) {
      InformationSettingsUpdate(layerId, getAllDataLayerId);
    }
  });
}

/**
 * Check if layer is in local storage
 *
 * @param {string} layerId
 */
function CheckHideItems(layerId) {
  const getLocalStorage = getItemLocalStorage("HQinformationSettings");

  if (!getLocalStorage) return;

  const checkIfExist = getLocalStorage.find(
    (item) => item.layer === layerId && item.checkbox === true
  );

  return checkIfExist;
}
